const MF_NAMES = {
    REACT: 'mf_1383_reactive_credit_card_ui',
    PACC: 'mf_1383_pacc_credit_card_ui',
    SIGN_BLOCK: 'mf_1383_ccpp_sign_block_ui',
    ISSUE_BLOCK: 'mf_1383_ccpp_issue_block_ui',
    ROUTER: 'mf_1383_router_credit_card_ui',
    ADDITIONAL_CC: 'mf_1383_additional_credit_card_ui',
    CONSENTS: 'mf_1383_ccpp_consents_ui',
    CLIENT_APPLICATION: 'mf_1383_ccpp_client_application_ui'
}

const HCMS_NAMES = {
    REACT: 'REACT_LOCALE_WEB',
    PACC: 'PACC_LOCALE_WEB_MF',
    SIGN_BLOCK: 'SIGN_BLOCK_LOCALE_WEB',
    ISSUE_BLOCK: 'ISSUE_BLOCK_LOCALE',
    ADDITIONAL_CC: 'ADDITIONAL_CC_LOCALE_WEB',
    CONSENTS: 'CONSENTS_LOCALE_WEB',
    CLIENT_APPLICATION: 'APPLICATION_LOCALE_WEB'
}

export const SERVICES = [
  { id: 1, label: "Реактивная КК", mf_name: MF_NAMES.REACT, mf_locale_name: HCMS_NAMES.REACT },
  { id: 2, label: "Проактивная КК", mf_name: MF_NAMES.PACC, mf_locale_name: HCMS_NAMES.PACC },
  { id: 3, label: "Анкета", mf_name: MF_NAMES.CLIENT_APPLICATION, mf_locale_name: HCMS_NAMES.CLIENT_APPLICATION },
  { id: 4, label: "Доп карта", mf_name: MF_NAMES.ADDITIONAL_CC, mf_locale_name: HCMS_NAMES.ADDITIONAL_CC },
  { id: 5, label: "Блок подписания", mf_name: MF_NAMES.SIGN_BLOCK, mf_locale_name: HCMS_NAMES.SIGN_BLOCK },
  { id: 6, label: "Блок выдачи", mf_name: MF_NAMES.ISSUE_BLOCK, mf_locale_name: HCMS_NAMES.ISSUE_BLOCK },
  { id: 7, label: "Чек продукт (роутер)", mf_name: MF_NAMES.ROUTER, mf_locale_name: '' },
  { id: 8, label: "Согласия", mf_name: MF_NAMES.CONSENTS, mf_locale_name: HCMS_NAMES.CONSENTS },
];